module.exports = "https://r.nearpod.com/assets/media/image/gs_paywall-aebd548ec580841e546069558c43240f.svg";